<!--
 * @Description: 
 * @Author: dyl
 * @Date: 2022-01-24 16:35:55
 * @LastEditTime: 2022-02-21 11:11:24
 * @LastEditors: Please set LastEditors
-->
<template>
  <div>
    <w-modal
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      custom-class="upload-container"
      :title="title"
      :before-close-button="beforeClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="50%"
      :append-to-body="true"
      top="15vh"
    >
      <div class="flex content">
        <div class="fileInfo">
          <p
            v-if="fileListInfo.length > 0"
            style="margin: 0px; text-align: left"
          >
            已经上传的图片：
          </p>
          <div
            v-for="(item, index) in fileListInfo"
            :key="item.name"
            class="image-li"
          >
            <img
              :src="item.PHYNAME"
              :class="[
                item.active && uploadType === 'view' ? 'img-active' : '',
                'img'
              ]"
              @click="showDetailImage(item, index)"
            />
            <div v-if="uploadType === 'add'" class="delete-img">
              <i class="el-icon-delete" @click="deleteImg(item)"></i>
            </div>
          </div>
        </div>
        <div v-if="uploadType === 'add'" class="upload-image">
          <div class="mb-20">
            <span class="mr-10">新上传文件</span>
            <w-radio
              v-model="type"
              label="1"
              size="small"
              @click="changeType(false)"
            >
              从本地文件上传
            </w-radio>
            <w-radio
              v-model="type"
              label="2"
              size="small"
              @click="changeType(true)"
            >
              从粘贴板上传
            </w-radio>
          </div>
          <w-upload
            v-if="uploadInfo.uploadType !== 'view' && type == '1'"
            :action="action"
            :data="dataObj"
            accept="image/png, image/jpeg, image/jpg"
            :multiple="multiple"
            :show-file-list="showFileList"
            :http-request="uploadFile"
            class="upload-demo"
            drag
          >
            <i class="w-icon-upload"></i>
            <div class="w-upload__text">
              将文件拖到此处，或
              <em>点击上传</em>
            </div>
            <div slot="tip" class="w-upload__tip">只能上传jpg/png文件</div>
          </w-upload>
          <div
            v-if="type == '2'"
            id="preview"
            class="upload-demo"
            @paste="handlePaste"
          >
            <span>按Ctrl+V 将图片粘贴至此处</span>
          </div>
        </div>
        <div v-if="uploadType === 'view'" class="upload-image">
          <viewer :images="imagePathList">
            <img :src="currrentImageInfo.PHYNAME" class="large-img" />
          </viewer>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <w-button @click="dialogClose">取 消</w-button>
        <w-button type="primary" @click="hanleSaveImage">确定</w-button>
        <w-button type="primary" @click="toggleImageType">{{
          btnName
        }}</w-button>
      </span>
    </w-modal>
  </div>
</template>

<script>
import axios from 'axios'
// 预览效果见付费文章

export default {
  name: 'UploadDialog',
  props: {
    dialogClose: {
      type: Function,
      default: () => {}
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    uploadInfo: {
      type: Object,
      default: () => {}
    },
    showFileList: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: 1
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    isResult: {
      type: String,
      default: 0
    }
  },
  data() {
    return {
      dataObj: { token: '', key: '' },
      userInfo: {},
      action: '',
      headers: {},
      fileListInfo: [],
      imagePathList: [],
      currrentImageInfo: {},
      title: '上传附件图片',
      uploadType: 'add',
      btnName: '查看已上传图片',
      type: '1',
      uploadImgFlag: false
    }
  },
  computed: {
    imageUrl() {
      return this.value
    }
  },
  watch: {
    dialogVisible: {
      handler() {
        this.getImageList()
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.uploadType = this.uploadInfo.uploadType
      ? this.uploadInfo.uploadType
      : 'add'
    this.userInfo = this.$store.state.user.loginUserInfo
    this.title = this.uploadType === 'view' ? '查看上传图片' : this.title
    this.uploadImgFlag = true
  },
  destroyed() {
    this.uploadImgFlag = false
  },
  methods: {
    // 原来的mvc中的实现方式（测试正常），暂时不用，只需要created中调用一下即可
    init() {
      let that = this
      // demo 程序将粘贴事件绑定到 document 上
      document.addEventListener(
        'paste',
        function (e) {
          if (!that.uploadImgFlag) {
            return
          }

          var cbd = e.clipboardData
          var ua = window.navigator.userAgent

          // 如果是 Safari 直接 return
          if (!(e.clipboardData && e.clipboardData.items)) {
            return
          }

          // Mac平台下Chrome49版本以下 复制Finder中的文件的Bug Hack掉
          if (
            cbd.items &&
            cbd.items.length === 2 &&
            cbd.items[0].kind === 'string' &&
            cbd.items[1].kind === 'file' &&
            cbd.types &&
            cbd.types.length === 2 &&
            cbd.types[0] === 'text/plain' &&
            cbd.types[1] === 'Files' &&
            ua.match(/Macintosh/i) &&
            Number(ua.match(/Chrome\/(\d{2})/i)[1]) < 49
          ) {
            return
          }

          var flag = 0
          for (var i = 0; i < cbd.items.length; i++) {
            var item = cbd.items[i]
            if (item.kind == 'file') {
              var blob = item.getAsFile()
              if (blob.size === 0) {
                that.$msg('未获取到图片')
                return
              }
              // blob 就是从剪切板获得的文件 可以进行上传或其他操作
              let file = new window.File([blob], blob.name, { type: blob.type })
              that.uploadFile({ file: file })
              flag++
            }
          }
          if (flag == 0) {
            that.$msg('未获取到图片', { icon: 5 })
            return
          }
        },
        false
      )
    },
    changeType(type) {
      this.uploadImgFlag = type
    },
    // 监听粘贴操作
    handlePaste(event) {
      const items = (event.clipboardData || window.clipboardData).items
      let file = null
      if (!items || items.length === 0) {
        this.$message.error('当前浏览器不支持本地')
        return
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          file = items[i].getAsFile()
          break
        }
      }
      if (!file) {
        this.$message.error('粘贴内容非图片')
        return
      }
      // 此时file就是我们的剪切板中的图片对象
      // 如果需要预览，可以执行下面代码
      const reader = new FileReader()
      reader.onload = (event) => {
        preview.innerHTML = `<img id="pase-img" src="${event.target.result}" style="max-width: 400px;max-height:400px;">` // 添加style样式保证图片等比缩放
      }
      reader.readAsDataURL(file)
      this.uploadFile({ file: file })
    },
    getImageList() {
      const obj = {
        Cfxh: this.uploadInfo.CFXH,
        Bzdm: this.uploadInfo.BZDM,
        Kfdm: this.uploadInfo.KFDM,
        Xh: this.uploadInfo.XSXH,
        OptType: parseInt(this.isResult)
      }
      this.$requestApi('GetZkjcImageInfo', obj).then((res) => {
        this.fileListInfo = res.data
        this.$emit('updateNum', this.fileListInfo.length)
        if (this.uploadType === 'view' && res.data.length > 0) {
          this.showDetailImage(this.fileListInfo[0], 0)
        }
      })
    },
    rmImage() {
      this.emitInput('')
    },
    emitInput(val) {
      this.$emit('input', val)
    },

    beforeClose() {
      this.dialogClose()
    },
    hanleSaveImage() {
      this.dialogClose()
    },

    showDetailImage(item, index) {
      this.fileListInfo.forEach((fl) => {
        fl.active = false
      })
      this.imagePathList = this.fileListInfo
      this.currrentImageInfo = item
      this.$nextTick(function () {
        this.fileListInfo[index].active = true
      })
    },
    // 删除图片
    deleteImg(item) {
      const obj = {
        Cfxh: this.uploadInfo.CFXH,
        Bzdm: this.uploadInfo.BZDM,
        Kfdm: this.uploadInfo.KFDM,
        Xh: this.uploadInfo.XSXH,
        AttachId: item.ATTACHID
      }
      this.$requestApi('DelZkjcImageInfo', obj).then((res) => {
        this.fileListInfo = res.data || []
        this.$emit('updateNum', this.fileListInfo.length)
      })
      // this.callbackDelete(item)
    },
    // 上传
    uploadFile(file) {
      let fd = new FormData()
      fd.append('file', file.file)
      fd.append('Cfxh', this.uploadInfo.CFXH)
      fd.append('Bddm', this.uploadInfo.BDDM)
      fd.append('Bzdm', this.uploadInfo.BZDM)
      fd.append('Kfdm', this.uploadInfo.KFDM)
      fd.append('Xh', this.uploadInfo.XSXH)
      fd.append('UserCode', this.userInfo.UserId)
      //多人检查
      if (this.isMultiple) {
        fd.append('Jcz', this.$store.state.user.loginUserInfo.UserId)
      }
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      axios
        .post(`${window.globalConfig.BaseUrl}NQCS/UploadZkjcImage`, fd, config)
        .then((res) => {
          if (!res.data.success) {
            this.$message({
              message: res.data.message,
              customClass: 'close-msg'
            })
            var el = document.querySelector('.close-msg')
            if (el) el.style.cssText = 'z-index: 9999'
          } else {
            this.getImageList()
          }
        })
        .catch((error) => {
          this.$message(error)
        })
    },
    // 切换上传与查看图片
    toggleImageType() {
      if (this.uploadType === 'add') {
        this.uploadType = 'view'
        this.btnName = '返回上传图片'
        this.title = '上传附件图片'
      } else if (this.uploadType === 'view') {
        this.uploadType = 'add'
        this.btnName = '查看已上传图片'
        this.title = '查看上传图片'
      }
      this.getImageList()
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
/deep/ .upload-container .w-modal__body {
  margin: 8px 0px !important;
}
.content {
  align-items: flex-start;
}
.fileInfo {
  width: 28%;
  border-right: 1px solid #e3e2e2;
  height: 100%;
  min-height: calc(100vh - 300px);
  max-height: 450px;
  padding-right: 16px;
  text-align: center;
  overflow: auto;
  overflow-x: hidden;
  .image-li {
    display: flex;
    cursor: pointer;
    height: fit-content;
    width: 100%;
    position: relative;
    .img {
      width: 100%;
      border-radius: 4px;
      margin: 8px 0px 0px 0px;
      cursor: pointer;
      img {
        width: 100%;
      }
    }
    .delete-img {
      position: absolute;
      display: none;
      right: 10px;
      top: 15px;
      cursor: pointer;
      border-radius: 50%;

      background: rgba(255, 255, 255, 0.5);
      width: 32px;
      height: 32px;
      padding: 5px 0;
      text-align: center;
      font-size: 18px;
    }
    &:hover {
      .img {
        opacity: 0.8;
      }
      .delete-img {
        display: block;
      }
    }
  }
}

.upload-image {
  border-left: 1px solid #e3e2e2;
  width: 72%;
  margin-top: 10px;
  text-align: center;
  cursor: pointer;
  .large-img {
    width: 90%;
    height: fit-content;
  }
}
.img-active {
  border: 4px solid #10a3e7;
}
</style>
